import * as A from 'fp-ts/Array';
import * as EQ from 'fp-ts/Eq';
import { flow, pipe } from 'fp-ts/function';
import * as N from 'fp-ts/number';
import { createContext, useContext, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var OffsetContext = /*#__PURE__*/createContext(null);
var htmlElementEq = EQ.eqStrict;
export var GlobalStickyOffset = function GlobalStickyOffset(_ref) {
  var children = _ref.children;
  var top = useState([]);
  var bottom = useState([]);
  return /*#__PURE__*/_jsx(OffsetContext.Provider, {
    value: {
      top: top,
      bottom: bottom
    },
    "data-element": "unknown",
    "data-component": "GlobalStickyOffset",
    "data-source-file": "global-sticky-offset.tsx",
    children: children
  });
};
export default GlobalStickyOffset;

var createHandlers = function createHandlers(type) {
  return {
    useElement: function useElement() {
      var ctx = useContext(OffsetContext);
      if (ctx === null) throw new Error('This hook needs to be used within `GlobalStickyOffset` component');
      var setState = ctx[type][1];

      var _useState = useState(null),
          element = _useState[0],
          setElement = _useState[1];

      useEffect(function () {
        if (element === null) return;
        setState(flow(A.append(element), A.uniq(htmlElementEq)));
        return function () {
          setState(A.difference(htmlElementEq)([element]));
        };
      }, [element]);
      return setElement;
    },
    useValue: function useValue() {
      var ctx = useContext(OffsetContext);
      if (ctx === null) throw new Error('This hook needs to be used within `GlobalStickyOffset` component');
      return pipe(ctx[type][0], A.foldMap(N.MonoidSum)(function (el) {
        return el.offsetHeight;
      }));
    }
  };
};

var _createHandlers = createHandlers('top'),
    useGlobalTopOffsetElement = _createHandlers.useElement,
    useGlobalTopOffsetValue = _createHandlers.useValue;

export { useGlobalTopOffsetElement, useGlobalTopOffsetValue };

var _createHandlers2 = createHandlers('bottom'),
    useGlobalBottomOffsetElement = _createHandlers2.useElement,
    useGlobalBottomOffsetValue = _createHandlers2.useValue;

export { useGlobalBottomOffsetElement, useGlobalBottomOffsetValue };